import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 10,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  },
  columnContent1: {
    width: '6%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  },
  totalRow: {
    flexDirection: 'row',
    marginTop: 5,
    marginBottom: 10,
    backgroundColor: '#f0f0f0',
    borderTopWidth: 1,
    borderTopColor: '#000',
    padding: 5
  },
  totalText: {
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'right',
    paddingRight: 10
  },
  totalValue: {
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  grandTotalRow: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 5,
    backgroundColor: '#d3d3d3',
    borderTopWidth: 2,
    borderTopColor: '#000',
    padding: 8
  },
  sectionHeader: {
    fontSize: '10px',
    fontFamily: 'Roboto',
    color: 'red',
    marginTop: 10,
    marginBottom: 5
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#e0e0e0', '#ffffff'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const DoctorLedgerSummaryReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const groupByDate = (data) => {
    return data.reduce((groups, item) => {
      const date = formatDate(item?.date);
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(item);
      return groups;
    }, {});
  };

  const groupByService = (data) => {
    return data.reduce((acc, curr) => {
      const serviceName = curr.serviceDetail?.service_name || 'Unknown';
      if (!acc[serviceName]) {
        acc[serviceName] = [];
      }
      acc[serviceName].push(curr);
      return acc;
    }, {});
  };

  // Format the grouped data to render in your PDF
  const groupedData = groupByDate(data?.ipdBillingData?.data);
  const opdGroupData = data?.groupedData;
  const opdBillingGroupData = groupByDate(data?.opdBillingData?.data);

  // Calculate totals for OPD Consultancy
  const opdConsultancyTotal = Object.values(opdGroupData || {}).reduce(
    (sum, group) => sum + (parseFloat(group.total_reg_amount) || 0),
    0
  );

  // Calculate totals for OPD Billing
  const opdBillingTotal = Object.values(opdBillingGroupData || {}).reduce(
    (sectionSum, items) => 
      sectionSum + items.reduce((itemSum, item) => itemSum + (parseFloat(item.total_amt) || 0), 0),
    0
  );

  // Calculate totals for IPD Billing
  const ipdBillingTotal = Object.values(groupedData || {}).reduce(
    (sectionSum, items) => 
      sectionSum + items.reduce((itemSum, item) => itemSum + (parseFloat(item.total_amt) || 0), 0),
    0
  );

  // Calculate Grand Total
  const grandTotal = opdConsultancyTotal + opdBillingTotal + ipdBillingTotal;

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Doctor Legder Detail Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <Text
              style={{ ...styles.Text, width: '100%', fontSize: '15px', textAlign: 'center', fontFamily: "Roboto" }}
              content={data?.groupedData ? Object.values(data.groupedData)[0].consultant_name : ''}
            />

            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '50%' }} content="Quantity" />
              <Text style={{ ...styles.columnHeader, width: '50%' }} content="Amount" />
            </View>

            {/* OPD Consultancy Section */}
            <View style={styles.row}>
              <Text style={styles.sectionHeader} content="OPD (Consultancy)" />
            </View>

            {Object.keys(opdGroupData || {}).map((groupDate, index) => {
              const groupInfo = opdGroupData[groupDate];
              return (
                <View key={groupDate} style={{ marginBottom: 5, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.header, fontSize: '10px', fontFamily: 'Roboto' }} content={groupDate} />
                  <View style={styles.row}>
                    <Text style={{ ...styles.columnContent, width: '50%' }} content={`${groupInfo.quantity}`} />
                    <Text style={{ ...styles.columnContent, width: '50%' }} content={`${groupInfo.total_reg_amount}`} />
                  </View>
                </View>
              );
            })}

            {/* OPD Consultancy Total */}
            <View style={styles.totalRow}>
              <Text style={{ ...styles.totalText, width: '50%' }} content="OPD Consultancy Total:" />
              <Text style={{ ...styles.totalValue, width: '50%' }} content={`${opdConsultancyTotal.toFixed(2)}`} />
            </View>

            {/* OPD Billing Section */}
            <View style={styles.row}>
              <Text style={styles.sectionHeader} content="OPD BILLING" />
            </View>

            {Object.keys(opdBillingGroupData || {}).map((groupDate, groupIndex) => {
              return (
                <View key={groupIndex} style={{ marginBottom: 5 }}>
                  <Text
                    style={{ ...styles.header, fontSize: 10, fontFamily: 'Roboto' }}
                    content={`Date: ${groupDate}`}
                  />
                  {opdBillingGroupData[groupDate].map((item, index) => (
                    <View key={index} style={{ marginBottom: 1 }}>
                      <Text
                        style={{ fontSize: 10, marginBottom: 5, fontFamily: 'Roboto' }}
                        content={item.service_name}
                      />
                      <View style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                        <Text style={{ ...styles.columnContent, width: '50%' }} content={item.service_count} />
                        <Text style={{ ...styles.columnContent, width: '50%' }} content={item.total_amt} />
                      </View>
                    </View>
                  ))}
                </View>
              );
            })}

            {/* OPD Billing Total */}
            <View style={styles.totalRow}>
              <Text style={{ ...styles.totalText, width: '50%' }} content="OPD Billing Total:" />
              <Text style={{ ...styles.totalValue, width: '50%' }} content={`${opdBillingTotal.toFixed(2)}`} />
            </View>

            {/* IPD Billing Section */}
            <View style={styles.row}>
              <Text style={styles.sectionHeader} content="IPD BILLING" />
            </View>

            {Object.keys(groupedData || {}).map((groupDate, groupIndex) => {
              return (
                <View key={groupIndex} style={{ marginBottom: 5 }}>
                  <Text
                    style={{ ...styles.header, fontSize: 10, fontFamily: 'Roboto' }}
                    content={`Date: ${groupDate}`}
                  />
                  {groupedData[groupDate].map((item, index) => (
                    <View key={index} style={{ marginBottom: 5 }}>
                      <Text
                        style={{ fontSize: 10, marginBottom: 1, fontFamily: 'Roboto' }}
                        content={item.service_name}
                      />
                      <View style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                        <Text style={{ ...styles.columnContent, width: '50%' }} content={item.service_count} />
                        <Text style={{ ...styles.columnContent, width: '50%' }} content={item.total_amt} />
                      </View>
                    </View>
                  ))}
                </View>
              );
            })}

            {/* IPD Billing Total */}
            <View style={styles.totalRow}>
              <Text style={{ ...styles.totalText, width: '50%' }} content="IPD Billing Total:" />
              <Text style={{ ...styles.totalValue, width: '50%' }} content={`${ipdBillingTotal.toFixed(2)}`} />
            </View>

            {/* Grand Total */}
            <View style={styles.grandTotalRow}>
              <Text style={{ ...styles.totalText, width: '50%', fontSize: 12 }} content="GRAND TOTAL:" />
              <Text style={{ ...styles.totalValue, width: '50%', fontSize: 12 }} content={`${grandTotal.toFixed(2)}`} />
            </View>

          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};